import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { bool } from "prop-types";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsChevronDown from "glesys-controlpanel/components/icons/chevron-down";
import { and, not } from "ember-truth-helpers";

@forbidExtraArgs
export default class Box extends Component {
  @arg(bool) collapsable = false;

  @arg(bool) showFooter = true;

  <template>
    <div class="relative [anchor-scope:all] flex flex-col" {{mergeClasses}} ...attributes>
      <details
        class="relative bg-white rounded outline-1 outline-gray-200 flex-1 flex flex-col details-content:flex details-content:flex-col details-content:flex-1 open:[&>summary]:border-b open:[&>summary_.box-summary-chevron]:rotate-180"
        data-test-box
        open={{not this.collapsable}}
      >
        <summary
          class="cursor-pointer flex items-center p-4 transition duration-300 ease-in-out border-gray-200 [&::-webkit-details-marker]:hidden
            {{if this.collapsable 'hover:bg-gray-50'}}
            {{unless this.collapsable 'pointer-events-none'}}
            {{unless (has-block 'header') 'hidden'}}
            "
          data-test-box-summary
          tabindex={{unless this.collapsable "-1"}}
        >
          {{#if (has-block "header")}}
            <div class="text-lg text-black mt-0 w-full">
              {{yield to="header"}}
            </div>
            <div class="[anchor-name:--header-actions]"></div>
            {{#if this.collapsable}}
              <div
                class="{{if
                    (has-block 'headerActions')
                    'w-9 h-8 mr-2 cursor-pointer flex items-center justify-center rounded-sm border border-gray-200 text-gray-600 hover:border-gray-200 hover:bg-gray-50 hover:text-gray-700'
                  }}"
              >
                <IconsChevronDown
                  class="text-gray-600 transition duration-300 box-summary-chevron"
                  role="presentation"
                />
              </div>
            {{/if}}
          {{/if}}
        </summary>
        <div class="flex flex-col flex-1">
          <div
            class="p-6 flex-1
              {{if (and (has-block 'footer') this.showFooter) 'pb-10'}}
              {{if (has-block 'header') 'flex flex-col'}}"
          >
            {{yield}}
          </div>
          {{#if (and (has-block "footer") this.showFooter)}}
            <div class="bg-gray-50 justify-end flex items-center rounded-b px-4 py-3 border-t border-gray-200 mt-4">
              {{yield to="footer"}}
            </div>
          {{/if}}
        </div>
      </details>
      {{#if (has-block "headerActions")}}
        <div
          class="absolute -translate-y-1/2
            {{if this.collapsable 'right-15' 'right-4'}}
            top-8 [position-anchor:--header-actions] [@supports(anchor-name:--header-actions)]:right-[anchor(left)] [@supports(anchor-name:--header-actions)]:top-[anchor(center)]"
          data-test-box-header-actions
        >
          {{yield to="headerActions"}}
        </div>
      {{/if}}
    </div>
  </template>
}
